import { getAppLanguage } from '../i18n';
import { isDesktop } from './isDesktop';

/**
 * Builds the login-web URL used by every login entry point (first login,
 * add-organisation, Electron IPC). The redirect target is `/login` on web and
 * a `cosafe://login` deep link on desktop.
 */
export function buildLoginWebUrl(): string {
  const redirectUrl = isDesktop() ? 'cosafe://login' : `${window.location.origin}/login`;
  return `${process.env.REACT_APP_LOGIN_WEB_URL}?${new URLSearchParams({
    redirectUrl,
    language: getAppLanguage(),
  }).toString()}`;
}
